<template>
  <div class="time-range">
    <div class="start-time" @click="showStart">{{ startTime.format('YYYY/MM/DD') }}</div>
    <div class="heng">-</div>
    <div class="end-time" @click="showEnd">{{ endTime.format('YYYY/MM/DD') }}</div>
  </div>
</template>

<script>
import moment from 'moment';
import { DatePicker } from 'cube-ui';
import { commonMixin } from 'common/js/mixin';

export default {
  mixins: [commonMixin],
  props: {
    startTime: {
      default() {
        return moment().subtract(1, 'months')
      }
    },
    endTime: {
      default() {
        return moment()
      }
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    showStart() {
      this.showDate('开始时间', new Date(this.startTime.valueOf()), (date) => {
        if(this.endTime.isBefore(date)) {
          this.showToast('开始时间不可超过结束时间', 'error');
          return false;
        }
        this.$emit('confirmStart', date);
      });
    },
    showEnd() {
      this.showDate('结束时间', new Date(this.endTime.valueOf()), (date) => {
        if(this.startTime.isAfter(date)) {
          this.showToast('开始时间不可超过结束时间', 'error');
          return false;
        }
        this.$emit('confirmEnd', date);
      });
    },
    showDate(title, value, selectFn, cancelFn) {
      let datePicker = this.$createDatePicker({
        title,
        value,
        onSelect: selectFn,
        onCancel: cancelFn
      });
      datePicker.show();
    }
  }
}
</script>

<style lang="scss" scoped>
.time-range {
  display: flex;
  .heng {
    margin: 0 10px;
  }
}
</style>


